export default __webpack_public_path__ + "static/viajes-ilus-11250759bb3d46722aa359bd17bc35ae.svg";